import request from '@/plugins/request';

export function getPdf(data) {
	return request({
		url: '/rentmanage/api/rentHouseSalesCard/esignDetail',
		method: 'get',
		params: data
	});
}

export function sendSignMobileCodeReq(data) {
	return request({
		url: '/storagemanage/api/esign/sendSignMobileCode3rd',
		method: 'get',
		params: data
	});
}

export function sign(data) {
	return request({
		url: '/storagemanage/api/esign/tenantCardSign',
		method: 'post',
		data: data
	});
}
